import AnchorVisibilityObserver from './src/AnchorVisibilityObserver';

AnchorVisibilityObserver.defineElement();
